import PropTypes from 'prop-types';
import React from 'react';
import { M } from '@dashboard-experience/mastodon';
import T from 'components/T';

import { DISPUTES_FLOW } from 'identifiers/identifiers';

const Checkbox = ({
  boldLabel,
  className,
  input,
  i18n,
  label,
  labelOptions,
  meta: { touched, error, warning },
}) => {
  const labelComponent = i18n ? (
    <T value={label} {...labelOptions} dangerousHTML />
  ) : (
    label
  );

  // A validation error is a translation key, or `{ message, ...params }` with
  // the params for that translation.
  const { message: errorKey, ...errorParams } =
    error && typeof error !== 'string' ? error : { message: error };
  const invalid = Boolean(touched && errorKey);
  const warn = Boolean(touched && !errorKey && warning);

  return (
    <M.Checkbox
      className={className}
      id={input.name}
      name={input.name}
      checked={!!input.value}
      // redux-form reads the value from the event, and the handlers some
      // fields pass as `onChange` read `event.target.checked`, so hand it the
      // DOM event rather than Carbon's (event, { checked, id }) arguments.
      onChange={event => input.onChange(event)}
      onBlur={event => input.onBlur(event)}
      onFocus={input.onFocus}
      // The test id sits inside the label, not on the input: Carbon hides the
      // native input behind its styled box, and the Cypress dispute flows
      // click this id (it used to be on the <label>), which toggles the box.
      labelText={
        <span data-testid={DISPUTES_FLOW.disputeAcceptCheckbox}>
          {boldLabel ? <b>{labelComponent}</b> : labelComponent}
        </span>
      }
      invalid={invalid}
      invalidText={
        invalid ? <T value={errorKey} {...errorParams} /> : undefined
      }
      warn={warn}
      warnText={warn ? warning : undefined}
    />
  );
};

Checkbox.propTypes = {
  boldLabel: PropTypes.bool,
  className: PropTypes.string,
  input: PropTypes.object,
  i18n: PropTypes.bool,
  label: PropTypes.string,
  labelOptions: PropTypes.object,
  meta: PropTypes.object,
  placeholder: PropTypes.string,
};

Checkbox.defaultProps = {
  boldLabel: false,
  className: '',
  input: {},
  i18n: false,
  label: '',
  labelOptions: {},
  meta: {},
  placeholder: '',
};

export default Checkbox;
